/* eslint-disable complexity */
import {
  IndividuelleWiederholung,
  TerminWeekdayOccurrence,
  TerminWiederholung,
  TerminWiederholungsIntervall,
} from '@/domain/termine/shared/types';
import dayjs from 'dayjs';

export const intervallMapToDayjsManipulateMap: Record<
  TerminWiederholungsIntervall,
  dayjs.ManipulateType
> = {
  [TerminWiederholungsIntervall.TAG]: 'day',
  [TerminWiederholungsIntervall.WOCHE]: 'week',
  [TerminWiederholungsIntervall.MONAT]: 'month',
  [TerminWiederholungsIntervall.JAHR]: 'year',
};

export const dayNumbers = (individuell: IndividuelleWiederholung) =>
  individuell?.wochentage &&
  individuell?.wochentage.map(
    (day) =>
      ({
        MONDAY: 1,
        TUESDAY: 2,
        WEDNESDAY: 3,
        THURSDAY: 4,
        FRIDAY: 5,
        SATURDAY: 6,
        SUNDAY: 0,
      })[day],
  );

const findLastWeekdayInMonth = (month: dayjs.Dayjs, dayNumber?: number) => {
  if (dayNumber === undefined) {
    return month.endOf('month');
  }
  let date = month.endOf('month');
  while (date.day() !== dayNumber) {
    date = date.subtract(1, 'day');
  }
  return date;
};

export const findNextWeekdayInMonth = (
  month: dayjs.Dayjs,
  dayNumber: number,
  occurrence: TerminWeekdayOccurrence,
): dayjs.Dayjs => {
  if (occurrence === TerminWeekdayOccurrence.FIXER_TAG) {
    return month;
  }

  if (occurrence === TerminWeekdayOccurrence.LETZTER) {
    return findLastWeekdayInMonth(month, dayNumber);
  }
  const occurrenceMap: Partial<Record<TerminWeekdayOccurrence, number>> = {
    [TerminWeekdayOccurrence.ERSTER]: 1,
    [TerminWeekdayOccurrence.ZWEITER]: 2,
    [TerminWeekdayOccurrence.DRITTER]: 3,
    [TerminWeekdayOccurrence.VIERTER]: 4,
  };
  const occurrenceCount = occurrenceMap[occurrence];

  let date = month.startOf('month');
  let count = 0;
  if (!occurrenceCount) return dayjs();

  while (count < occurrenceCount) {
    if (date.day() === dayNumber) count++;
    if (count < occurrenceCount) {
      date = date.add(1, 'day');
    }
  }
  return date;
};

export function isTerminRepetitionIntervall(
  value: TerminWiederholungsIntervall,
) {
  const validIntervals = Object.values(TerminWiederholungsIntervall);
  return validIntervals.some((interval) => interval === value);
}

export const wiederholungMap: Record<
  TerminWiederholung,
  dayjs.ManipulateType | null
> = {
  [TerminWiederholung.TAEGLICH]: 'day',
  [TerminWiederholung.WOECHENTLICH]: 'week',
  [TerminWiederholung.MONATLICH]: 'month',
  [TerminWiederholung.JAEHRLICH]: 'year',
  [TerminWiederholung.INDIVIDUELL]: null,
  [TerminWiederholung.OHNE]: null,
};
